import React, { FC } from 'react';
import { Form, Formik } from 'formik';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import Modal, { ModalProps } from 'components/Modal/Modal';
import FormikTextInput from 'components/forms/formik/FormikTextInput/FormikTextInput';
import SubmitButton from 'components/SubmitButton/SubmitButton';

import useInitialValues from './hooks/useInitialValues';
import useLoginSubmit from './hooks/useLoginSubmit';
import useSchema from './hooks/useSchema';

import './LoginModal.scss';

const AuctionDocumentsModalContent: FC<ModalProps> = ({ isOpen, onRequestClose }) => {
  const { t } = useTranslation();
  const schema = useSchema();
  const initialValues = useInitialValues();
  const onSubmit = useLoginSubmit();

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      variant="kliparo"
      className="enkrateia-login-modal"
      title={t('pages.login.loginModal.title')}
    >
      <Formik initialValues={initialValues} validationSchema={schema} onSubmit={onSubmit}>
        <Form>
          <FormikTextInput label={t('pages.login.form.email')} name="email" type="email" fullWidth />
          <FormikTextInput label={t('pages.login.form.password')} name="password" type="password" fullWidth />
          <SubmitButton submitVariant="form" variant="primary">
            {t('pages.login.form.submit')}
          </SubmitButton>
        </Form>
      </Formik>
      <Link to="/reset-password">{t('pages.login.form.forgotPassword')}</Link>
    </Modal>
  );
};

const LoginModal: FC<ModalProps> = ({ isOpen, onRequestClose }) => {
  if (!isOpen) {
    return null;
  }

  return <AuctionDocumentsModalContent isOpen={isOpen} onRequestClose={onRequestClose} />;
};

export default LoginModal;
